module.exports = __webpack_public_path__ + "static/FlowExample@2x-09eae4c5dd762661c966c2239f7cb30c.jpg";